import React, { useContext } from "react";
import { Link, useRouteMatch } from "react-router-dom";
import Context from "../../../Context";

export default function HeaderNotice() {
  const cx = useContext(Context);
  let isActive = useRouteMatch("/notice");

  let iconClass = "primary";
  let titleSuffix = "";
  let urlSuffix = "current";

  let isPulse = cx.notifier.buzz.notice === true ? true : false;
  if (isPulse) {
    iconClass = "info";
  }

  if (cx.notifier.notice.notice) {
    //iconClass = "warning";
    titleSuffix = `: новые ${cx.notifier.notice.notice}`;
  }
  if (cx.notifier.notice.interfere) {
    iconClass = "danger";
    titleSuffix = `: требуют внимания ${cx.notifier.notice.interfere}`;
    isPulse = true;
    urlSuffix = "interfere";
  }

  const pulseRing = isPulse ? <span className="pulse-ring"></span> : "";

  return (
    <div className="topbar-item">
      <Link to={`/notice/${urlSuffix}/`} title={`Уведомления${titleSuffix}`}>
        <div
          className={`btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-${iconClass} ${
            isActive ? "bg-light" : ""
          }`}
        >
          <span className={`svg-icon svg-icon-xl svg-icon-${iconClass}`}>
            <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
              <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <path
                  d="M17,12 L18.5,12 C19.3284271,12 20,12.6715729 20,13.5 C20,14.3284271 19.3284271,15 18.5,15 L5.5,15 C4.67157288,15 4,14.3284271 4,13.5 C4,12.6715729 4.67157288,12 5.5,12 L7,12 L7.5582739,6.97553494 C7.80974924,4.71225688 9.72279394,3 12,3 C14.2772061,3 16.1902508,4.71225688 16.4417261,6.97553494 L17,12 Z"
                  fill="#000000"
                />
                <rect
                  fill="#000000"
                  opacity="0.3"
                  x="10"
                  y="16"
                  width="4"
                  height="4"
                  rx="2"
                />
              </g>
            </svg>
          </span>
          {pulseRing}
        </div>
      </Link>
    </div>
  );
}
